import { get } from 'lodash';
import { applicationProductFormats } from 'constants/products';
import { getFormatForProduct } from 'products/fertility-selectors';
import { applicationTypes } from 'constants/scripts';

export const getApplicationProductsByChemicalTypeUuid = (state) => {
  let response = state.products[`${applicationTypes.APPLICATION}`].productsByChemicalTypeUuid;

  for (let key in response) { // To filter deleted products
    if (response.hasOwnProperty(key)) {
      response[key] = response[key].filter(product => product.status !== 'deleted');
    }
  }
  return response;
};

export const getProductById = ({ applicationType, id, state }) =>
  get(state, `products.${applicationType}.productsById.${id}`);
export const getFullProductNameFromProduct = (product) =>
  `${product.brand} ${product.name}`;
export const getNitrapyrin = (state) => {
  let nitrapyrin = {};
  let stabilizers = get(state, 'products.stabilizer');
  if (Object.keys(stabilizers).length === 0) {
    return nitrapyrin;
  }
  if (stabilizers.productsById) {
    stabilizers = stabilizers.productsById;
    Object.values(stabilizers).forEach((stabilizer) => {
      if (stabilizer.name === 'Nitrapyrin') {
        nitrapyrin.id = stabilizer.id;
        nitrapyrin.name = stabilizer.name;
      }
    });
  }
  return nitrapyrin;
};

export const getFormatFromApplicationIncorporationMethod = (
  incorporationMethod
) => {
  return incorporationMethod === 'liquid' || incorporationMethod === 'sprayed'
    ? applicationProductFormats.WET
    : applicationProductFormats.DRY;
};

export const getFormatFromZones = (zones) => {
  const [zone] = Object.values(zones);
  const applications = Object.keys(zone.meta.applications);
  if (applications.includes('application')) {
    return getFormatFromApplicationIncorporationMethod(
      zone.meta.applications.application[0].incorporationMethod
    );
  } else if (applications.includes('seed')) {
    const seed = zone.meta.applications.seed[0];
    if (seed && seed.hasOwnProperty('product')) {
      return getFormatForProduct(zone.meta.applications.seed[0].product);
    }
    return null;
  } else {
    return getFormatForProduct(zone.meta.applications.fertilizer[0].product);
  }
};
